import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings-menu" }
const _hoisted_2 = { class: "settings-menu__items" }
const _hoisted_3 = { class: "heading-xl" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1 1"} }, null, -1)
const _hoisted_5 = { class: "settings-menu__build-info" }
const _hoisted_6 = { class: "label-xs" }
const _hoisted_7 = { class: "label-mono-xs" }
const _hoisted_8 = { class: "label-xs" }
const _hoisted_9 = { class: "label-mono-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarMenu = _resolveComponent("SidebarMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('common.preferences', 'f')), 1),
      _createVNode(_component_SidebarMenu, { "menu-items": _ctx.menuItems }, null, 8, ["menu-items"])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('common.build_version', 'f')) + ":", 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.applicationModule.product) + "." + _toDisplayString(_ctx.applicationModule.build_version), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('common.build_date', 'f')) + ":", 1),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$filters.formatDateTime(_ctx.applicationModule.build_date)), 1)
    ])
  ]))
}